import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const CampaignsIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M3.51429 4.62129H2.14286C1.38544 4.62129 0.771429 5.2353 0.771429 5.99272V8.73557C0.771429 9.49299 1.38544 10.107 2.14286 10.107H3.51429M3.51429 4.62129V10.107M3.51429 4.62129V10.107M3.51429 4.62129C3.51429 3.86387 4.1283 3.24986 4.88571 3.24986H9M3.51429 10.107C3.51429 10.8644 4.1283 11.4784 4.88572 11.4784H9M9 3.24986V11.4784M9 3.24986L16.326 0.807855C16.77 0.659848 17.2286 0.990341 17.2286 1.45838V13.2699C17.2286 13.738 16.77 14.0684 16.326 13.9204L9 11.4784M4.88571 11.4784H7.62857V15.5927C7.62857 16.3501 7.01456 16.9641 6.25714 16.9641C5.49972 16.9641 4.88571 16.3501 4.88571 15.5927V11.4784Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </Svg>
);

CampaignsIcon.displayName = 'CampaignsIcon';
